﻿import $ from 'jquery';
import ko from 'knockout';
import { IBinder, IBehaviorBinding, ICellBinding } from "./ibinder"

export class HiddenInputBinder implements IBinder {
  public getElements(row: JQuery): JQuery {
    var hiddenInputs = row.find(":input[type='hidden']:not([data-et-json])").filter(function () {
      var name = $(this).attr("name");
      var siblings = $(this).siblings("input[type='checkbox'][name='" + name + "']");
      if (siblings.length > 0)
        return false;
      return true;
    });
    return hiddenInputs;

  }
  public getBinding(cell: JQuery): ICellBinding {
    var cellName = cell.attr("name");
    var value = cell.val();

    return {
      dataName: cellName,
      dataValue: ko.observable(value),
      bindingName: "init, value",
      bindTo: cellName,
      createEmptyValue: () => ko.observable()

    };
  }
}
